import Hero from '../components/Hero/Hero';
import Companies from '../components/Companies/Companies';

export default function Home() {
  return (
    <main>
      <Hero />
      <Companies />
    </main>
  );
}
